module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "calendar"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8851eef6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FullCalendar.vue
// module id = 616
// module chunks = 1